import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import GerberFile from 'shared/components/parameters/GerberFile';
import { processFile as processZipFile } from 'shared/product_tabs/tab_parts/slice/process_file';
import { selectFabricationDataForZipFile } from 'taiwan_pcb/pcb_fabrication/slice/selectors';

const tooltip = `For Fabrication please include in the Zip File:
- Gerber files.
- Fabrication Notes (if available)
- Fabrication Drawings (if available)

For Assembly please include in the Zip File:

- BOM
- XY Data
- Assembly Drawings (If available)
- Assembly Notes (if available)`;

const fabRequireFile = () => {
  const {
    destroy,
    lineItemId,
  } = useSelector(selectFabricationDataForZipFile);

  if (!destroy && lineItemId) return false;

  return true;
};

const stencilRequireFile = (stencils) => {
  if (stencils.length === 0) return false;

  const anyNew = stencils.find((stencil) => !stencil.line_item_id);

  if (anyNew) return true;

  return false;
};

const ZipFile = (props) => {
  const { validator, onChangeParameter } = props;
  const dispatch = useDispatch();
  const {
    parameters,
  } = useSelector(selectFabricationDataForZipFile);

  const {
    stencils,
  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  } = useSelector((state) => state.stencils);

  const processFile = (file) => {
    dispatch(processZipFile(file));
  };

  const requireFile = fabRequireFile() || stencilRequireFile(stencils);

  return (
    <GerberFile
      parameters={parameters}
      processFile={processFile}
      label={Spree.translations.gerber_file}
      text={Spree.translations.gerber_file_text}
      tooltip={tooltip}
      errorMessage={requireFile && validator.message('Zip file', parameters.filename, 'required')}
      onChangeParameter={onChangeParameter} />
  );
};

export default ZipFile;
